import axios from './index';

export const _getAPICode = () => {
  return axios.get(`public/v1/app/get-api-code`);
};

export const _createAPICode = (reqObj) => {
  return axios.post(`public/v1/app/create-api-code`, reqObj);
};

export const _updateAPICode = (reqObj) => {
  return axios.put(`public/v1/app/update-api-code`, reqObj);
};

export const _updateAPICodeStatus = (reqObj) => {
  return axios.put(`public/v1/app/update-api-code-status`, reqObj);
};
